// extracted by mini-css-extract-plugin
export default {"sliderContainer":"dKi4dlJyAZ"};